import React from 'react';
import './skeleton.css';

interface SkeletonChartProps {
  height?: number;
  width?: string;
  title?: boolean;
}

const SkeletonChart: React.FC<SkeletonChartProps> = ({
  height = 300,
  width = '100%',
  title = true
}) => {
  return (
    <div className="skeleton-chart-container" style={{ width }}>
      {title && (
        <div className="skeleton-chart-title skeleton-shimmer" />
      )}
      <div
        className="skeleton-chart-body skeleton-shimmer"
        style={{ height: `${height}px` }}
      />
    </div>
  );
};

export default SkeletonChart;
